/* Foxify cross-sell card buttons labelled "VIEW PRODUCT" were wired to
   add-to-cart by default. Intercept the click so it navigates to the
   product page instead, matching the label.
   Loaded site-wide via theme.foxify.liquid + theme.liquid. */
(function () {
  'use strict';

  var URL_BY_TITLE = {
    'farm scale soil microbes & feeder': '/products/soil-microbes-and-feeder',
    'farm scale soil microbes and feeder': '/products/soil-microbes-and-feeder',
    'custom microbes (pgpr)': '/products/custom-microbes-pgpr',
    'custom microbes pgpr': '/products/custom-microbes-pgpr',
    'farm consultation': '/products/farm-consultation',
    'pot trial': '/products/pot-trial',
    'pot trials': '/products/pot-trial',
    'dna testing': '/products/dna-testing',
    'soil dna testing': '/products/soil-dna-testing'
  };

  function findProductUrl(btn) {
    /* 1. Try nearest ancestor anchor pointing at /products/ */
    var card = btn.closest('.x-cell, .x-stack, .x-product-card, .x-section') || btn.parentElement;
    if (card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (link) return link.getAttribute('href');
    }

    /* 2. Try matching nearest visible title to the lookup table */
    var search = btn.closest('.x-cell, .x-stack, .x-section') || btn.parentElement;
    if (!search) return null;
    var titleEls = search.querySelectorAll('h1, h2, h3, h4, .x-text, [class*="title"], [class*="heading"]');
    for (var i = 0; i < titleEls.length; i++) {
      var t = (titleEls[i].textContent || '').trim().toLowerCase();
      if (URL_BY_TITLE[t]) return URL_BY_TITLE[t];
    }
    return null;
  }

  function rewrite() {
    var buttons = document.querySelectorAll('.x-button, button.x-button, a.x-button, [class*="x-button"]');
    buttons.forEach(function (btn) {
      if (btn.dataset.slViewProductFixed) return;
      var label = (btn.textContent || '').trim().toUpperCase();
      if (label !== 'VIEW PRODUCT' && label !== 'ADD TO CART') return;

      var url = findProductUrl(btn);
      if (!url) return;

      btn.dataset.slViewProductFixed = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        window.location.href = url;
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(rewrite, 800); });
  } else {
    setTimeout(rewrite, 800);
  }
  /* Re-run on later DOM mutations (foxify renders async) */
  setTimeout(rewrite, 1800);
  setTimeout(rewrite, 3500);
})();
